"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteNode = void 0;
const url_utils_1 = require("./url.utils");
class RouteNode {
    relativeUrl;
    _absoluteUrl;
    constructor(relativeUrl, options = {}) {
        this.relativeUrl = relativeUrl;
        this.children = options.children ?? this.children;
        this.params = options.params ?? this.params;
        this.queryParams = options.queryParams ?? this.queryParams;
        if (this.children) {
            for (const child of Object.values(this.children)) {
                child._setParent(this);
            }
        }
        this._validateParamsInUrl();
    }
    children = {};
    params = {};
    queryParams = {};
    parent;
    get absoluteUrl() {
        if (!this._absoluteUrl) {
            if (this.relativeUrl) {
                this._absoluteUrl = (this.parent?.absoluteUrl || '') + '/' + this.relativeUrl;
            }
            else {
                this._absoluteUrl = (this.parent?.absoluteUrl || '');
            }
        }
        return this._absoluteUrl;
    }
    get absoluteUrlWithoutLeading() {
        return this.absoluteUrl.slice(1);
    }
    get relativeUrlWithParent() {
        return this.getRelativeWithParents(1);
    }
    getRelativeWithParents(numberOfParents) {
        if (numberOfParents > 1000) {
            throw new Error('Too high numberOfParents!');
        }
        let result = this.relativeUrl;
        let levels = numberOfParents;
        let currentParentNode = this.parent;
        while (currentParentNode && levels > 0) {
            if (currentParentNode.relativeUrl) {
                result = result ? `${currentParentNode.relativeUrl}/${result}` : currentParentNode.relativeUrl;
            }
            levels--;
            currentParentNode = currentParentNode.parent;
        }
        return result;
    }
    getAbsoluteUrlWithParams(params, query) {
        let result = this.absoluteUrl;
        for (const [param, val] of Object.entries(params)) {
            result = result.replace(':' + param, val);
        }
        if (query) {
            result = url_utils_1.UrlUtils.addQueryToUrl(result, query);
        }
        return result;
    }
    getAbsoluteUrlWithQuery(query) {
        return url_utils_1.UrlUtils.addQueryToUrl(this.absoluteUrl, query);
    }
    _setParent(parent) {
        this.parent = parent;
    }
    _validateParamsInUrl() {
        const paramsFoundInUrl = this.relativeUrl.match(/:[^\/]*/g);
        if (paramsFoundInUrl?.length) {
            const paramsValues = new Set(Object.values(this.params).map(_ => `:${_}`));
            const missingParamDefinitions = paramsFoundInUrl.filter(paramInUrl => !paramsValues.has(paramInUrl));
            if (missingParamDefinitions.length) {
                throw new Error(`Missing param definition\n\t-> RouteNode: "${this.absoluteUrl}"\n\t-> Missing params: ${missingParamDefinitions.join(', ')}`);
            }
        }
    }
}
exports.RouteNode = RouteNode;
